import React from 'react';
import { Box } from '@mui/material';
import InfoIcon from '@square-icons/react/16/UI/circle-info';
import { BASE_THEME as baseTheme } from 'theme/shop_theme';

const VARIANTS = {
  info: baseTheme.color.lightBlue,
  warning: baseTheme.color.orange,
  error: baseTheme.color.red,
  success: baseTheme.color.green,
  generic: baseTheme.color.gray['5'],
};

const InfoBubble = (props) => {
  const {
    children,
    icon = InfoIcon,
    iconSpacing = 2, // controls how much margin between icon & text content
    my = 0,
    spacing = 3,
    variant = 'info',
  } = props;

  if (!VARIANTS[variant]) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: VARIANTS[variant],
        borderRadius: 1,
        display: 'flex',
        my,
        padding: spacing,
      }}
    >
      <Box
        alignItems="center"
        display="flex"
        ml={iconSpacing - spacing}
        mr={iconSpacing}
      >
        {icon}
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};

export default InfoBubble;
